import React from "react";
import ScrollToTopButton from "../components/scrollTopButton";
import JoliPhonicComponent from "../components/JoliPhonicComponent";
import { UrduSoundsData } from "../assets/data/UrduSoundsData";

const UrduSounds = () => {
  return (
    <div className="mt-44" dir="rtl" style={{ textAlign: "right", }}> {/* Adjust the top margin */}
      {/* Render items in the group */}
      <div className="flex flex-wrap gap-4 justify-center md:justify-start md:ml-12">
        {UrduSoundsData.map((phonic, index) => (
          <JoliPhonicComponent
            key={index}
            title={phonic.title}
            thumbnail={phonic.thumbnail}
            audioUrl={phonic.audioUrl}
          />
        ))}
      </div>
      {/* Circular button to scroll to top */}
      <ScrollToTopButton />
    </div>
  );
};

export default UrduSounds;